export default {
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  ALL: "ALL"
};
